export default __webpack_public_path__ + "cf4dd21de314c5d9746f09200b81bfab.png";